import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, ContentNode as TContentnode, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ContentNode, ImageEntity, UiComponentName, useComponentProps, useLang } from '@shapeable/ui';
import { LinkButton } from '@shapeable/ui';
import { CtaImage } from '../../data';
import { ChevronRightThinIconGlyph } from '@shapeable/icons';

const cls = classNames('post-aside-cta');

// -------- Types -------->

// -------- Props -------->

export type PostAsideCtaProps = Classable & HasChildren & {
  ctaText?: string;
}

export const PostAsideCtaDefaultProps: PostAsideCtaProps = {
  ctaText: 'ConnectOre is an industry-wide collaboration to unlock innovation, advance responsible practices, and tackle mining industry challenges that are beyond the scope of any single organisation.',
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.UNIT(4)};
    padding: ${theme.UNIT(4)};
  `,
});

const CtaTextStyles = breakpoints({
  base: css`
    font-weight: 300;
    line-height: 1.3;
  `,
});

const CtaButtonStyles = breakpoints({
  base: css`
    flex-shrink: 0;
  `,
});

const ImageStyles = breakpoints({
  base: css`
    border-radius: ${theme.UNIT(4)};

  `,
});

const TextAndButtonStyles = breakpoints({
  base: css`
    display: flex;
    gap: ${theme.UNIT(2)};
    flex-direction: column;
  `,
  tablet: css`
    flex-direction: row;
  `,
});


// -------- Components -------->

const My = {
  NAME: 'PostAsideCta' as UiComponentName,

  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    TextAndButton: styled.div`${TextAndButtonStyles}`,
      CtaText: styled(ContentNode)`${CtaTextStyles}`,
      CtaButton: styled(LinkButton)`${CtaButtonStyles}`,
    Image: styled(ImageEntity)`${ImageStyles}`,
};

export const PostAsideCta: Shapeable.FC<PostAsideCtaProps> = (props) => {
  const { ctaText } = props;

  const { className, children } = useComponentProps(My.NAME, PostAsideCtaDefaultProps, props) as PostAsideCtaProps;
  
  const t = useLang();

  const content: TContentnode = {
    text: t(ctaText!),
  }

  return (
    <My.Container className={cls.name(className)}>
      <My.TextAndButton>
        <My.CtaText entity={content}>
        </My.CtaText>
        <My.CtaButton
          borderStyle='solid'
          icon={ChevronRightThinIconGlyph}
          href="/contact"
          colors={{
            border: 'mid',
            fill: 'mid',
            text: 'text',
            hover: {
              border: 'primary',
              fill: 'primary',
              text: 'primary',
            }
          }}
        >
          {t('Get Involved')}
        </My.CtaButton>
      </My.TextAndButton>
      <My.Image
        entity={CtaImage}
      />
      
    </My.Container>
  )
};

PostAsideCta.cls = cls;
PostAsideCta.defaultProps = PostAsideCtaDefaultProps;